// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e7c79e6","455":"889f58bd","467":"3db75a57","977":"da735cfd"}[chunkId] + ".chunk.js";
};